import { render } from "./Daily_Collections.vue?vue&type=template&id=42c0b8dc&scoped=true"
import script from "./Daily_Collections.vue?vue&type=script&lang=js"
export * from "./Daily_Collections.vue?vue&type=script&lang=js"

import "./Daily_Collections.vue?vue&type=style&index=0&id=42c0b8dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c0b8dc"]])

export default __exports__